export default __webpack_public_path__ + "static/media/slider_image_02-lg@1x.d45d7e58.webp";